<template>
	<div>
		<div class="id">
			<van-nav-bar :title="$t('video.video')">
				<template #right>
					<van-icon name="chat-o" size="24" color="#fff" @click="toLogin('/ServiceOnline')" />
				</template>
			</van-nav-bar>

			<van-tabs v-model="active" @change="vanTab()">
				<van-tab :title="item.name" :name="item.id" title-style="font-size:16px;line-height:50px;"
					v-for="item in videolitem" :key="item.id">
				</van-tab>
			</van-tabs>
		</div>

		<van-list v-model="loading" :finished="finished" :finished-text="$t('video.no_more')" :loading-text="$t('video.loading')"
			@load="onLoad">
			<div class="list-item">
				<div class="movie-list-item" v-for="(i,key) in data" :key="key" @click="toPlayVideo(i.id)">
					<img :src="i.image" class="cover_img" />
					<div class="movie-list-item-bottom" style="bottom: 33px;">
						<div class="movie-time-div">
							<span>{{ i.title }}</span>
							<span style="font-size: 12px;">
								{{$t("video.play")}}:{{ i.views }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</van-list>
		<div style="height: 55px;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				loading: false,
				finished: false,
				videolitem: [],
				data: [],
				page: 1,
				pageSize: 20,
				id: '',
			};
		},
		created() {
			this.getVideoClass();
		},
		methods: {
			//一进来调用
			onLoad() {
				this.loading = true;
				setTimeout(() => {
					// 2. 请求新数据（这里用模拟数据）
					this.getVideoList();
				}, 1000);

			},
			//切换
			vanTab() {
				console.log(this.active, '654564')
				this.finished = false
				this.id = this.active
				this.page = 1
				this.data = []
				this.getVideoList()
			},
			//跳转
			toPlayVideo(id) {
				this.$router.push({
					path: "/PlayVideo",
					query: {
						id
					}
				});
			},
			async getVideoList() {
				const {
					data,
					code
				} = await this.$http({
					method: "get",
					data: {
						type_id: this.id,
						page: this.page,
						limit: this.pageSize
					},
					url: "getFilmList",
				})
				console.log(data, this.page, '4646546546')
				if (code == 1) {
					if (data.length < 20) {
						this.finished = true;
					}
					this.data = [...this.data, ...data];
					this.page++;
					this.loading = false;
				} else {
					this.finished = true;
				}
			},
			toLogin(str) {
				this.$router.push({
					path: str
				});
			},
			//电影分类
			getVideoClass() {
				this.$http({
					method: "get",
					url: "getType",
				}).then((res) => {
					if (res.code == 1) {
						this.videolitem = res.data;
						this.id = res.data[0].id
					} else {
						this.$toast(res.msg);
					}

				});
			},
		},

	};
</script>

<style scoped lang="less">
	.id {
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 10;
		height: 200px;
	}

	.van-nav-bar {
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
	}

	::v-deep .van-tabs__nav {
		background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;

	}

	::v-deep .van-tab--active {
		color: #fff !important;
	}

	::v-deep .van-tab {
		color: #fff !important;
	}

	::v-deep .van-tabs__line {
		background-color: #fff !important;
	}


	::v-deep .van-tabs__wrap {
		height: 100px;
		padding-bottom: 10px;
	}

	/deep/ .van-loading__text {
		font-size: 32px;
		color: #000;
	}

	/deep/ .van-list__finished-text {
		font-size: 32px;
		color: #000;
	}

	/deep/ .van-pull-refresh__head {
		height: 100px;
	}

	/deep/ .van-pull-refresh__text {
		font-size: 32px;
		/* 设置字体大小 */
		color: #000;

	}

	.list-item {
		display: flex;
		width: calc(100% - 7vw);
		// height: calc(100vh - 380px);
		// overflow-x: auto;
		margin: 10px auto;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
		padding-top: 200px;
	}

	.movie-list-item {
		width: calc(50% - 16px);
		margin-bottom: -7vw;
	}

	.cover_img {
		border-radius: 10px;
		width: 100%;
		height: 200px;
		object-fit: cover;
	}

	.movie-list-item-bottom {
		position: relative;
		width: 100%;
		bottom: 6vw;
	}

	.movie-time-div {
		background-color: rgba(0, 0, 0, 0.4);
		color: #fff;
		border-radius: 0 0 10px 10px;
		padding: 0px 10px;
		width: 100%;
		height: 8vw;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 24vw;
		padding-left: 16px;
		font-size: 3vw;
	}
</style>